import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnRouteChange: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Temporarily disable smooth scrolling for instant scroll
    const originalBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    
    // Function to scroll to top
    const scrollToTop = () => {
      // Try multiple methods to ensure scroll works
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    // Immediate scroll
    scrollToTop();
    
    // Multiple attempts with different timings
    const timeouts = [
      setTimeout(scrollToTop, 0),
      setTimeout(scrollToTop, 10),
      setTimeout(scrollToTop, 50),
      setTimeout(scrollToTop, 100),
      // Restore smooth scroll behavior after scrolling is complete
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = originalBehavior;
      }, 150)
    ];
    
    // Use requestAnimationFrame for next render cycle
    const rafId = requestAnimationFrame(() => {
      scrollToTop();
      // Try again on next frame
      requestAnimationFrame(scrollToTop);
    });
    
    return () => {
      timeouts.forEach(clearTimeout);
      cancelAnimationFrame(rafId);
      // Restore original scroll behavior on cleanup
      document.documentElement.style.scrollBehavior = originalBehavior;
    };
  }, [pathname]);

  return null;
};

export default ScrollToTopOnRouteChange;